import { ErrorBox } from "@gearbox-protocol/deploy-tools-ui";
import type { FC, ReactNode } from "react";

import { InsolvencyReport } from "./insolvency";
import { TaskOptimist } from "./optimist";
import { TaskRouter } from "./router";
import TaskCommonTable from "./TaskCommonTable";
import useTask from "./useTask";

const TaskViewRoute: FC = () => {
  const task = useTask();
  if (!task) {
    return <ErrorBox>Task not found</ErrorBox>;
  }

  let details: ReactNode;
  if (task.status === "success" || task.status === "failed") {
    switch (task.family) {
      case "optimist":
        details = <TaskOptimist task={task} />;
        break;
      case "insolvency":
        details = <InsolvencyReport task={task} />;
        break;
      case "router":
        details = <TaskRouter task={task} />;
        break;
    }
  }

  return (
    <div className="flex flex-col rounded-xl bg-background p-4">
      <h3>{`Task ${task.name ?? task.definitionId}`}</h3>
      <TaskCommonTable task={task} />
      {task.error && <ErrorBox>{decodeURIComponent(task.error)}</ErrorBox>}
      {details}
    </div>
  );
};

export default TaskViewRoute;
